
export function countNetIncome(arr) {
  if (!Array.isArray(arr)) {
    throw new Error("O parâmetro deve ser um array.");
  }

  // Conta apenas valores maiores que zero
  const positivos = arr.filter(num => num > 0);
  return positivos.length;
}


export function countConsecutiveNetIncomeold(arr) {
  if (!Array.isArray(arr)) {
    throw new Error("O parâmetro deve ser um array.");
  }

  let maxConsecutivos = 0;
  let atualConsecutivos = 0;

  for (let i = 0; i < arr.length; i++) {
    if (arr[i] > 0) {
      atualConsecutivos++;
      if (atualConsecutivos > maxConsecutivos) {
        maxConsecutivos = atualConsecutivos;
      }
    } else {
      atualConsecutivos = 0; // quebra a sequência
    }
  }

  return maxConsecutivos;

}


export function countConsecutiveNetIncome(arr) {
  if (!Array.isArray(arr)) {
    throw new Error("O parâmetro deve ser um array.");
  }

  // Inverte o array para começar do último elemento
  const invertido = [...arr].reverse();

  let consecutivos = 0;

  for (let i = 0; i < invertido.length; i++) {
    if (invertido[i] > 0) {
      consecutivos++;
    } else {
      break; // para assim que encontrar um valor não positivo
    }
  }

  return consecutivos;
}

// Exemplo:

